/**
 * Supported Languages for VeevaID includes only system translated languages.
 * https://gitlab.veevadev.com/veevavault/vault/-/blob/develop/VeevaID/src/main/java/veeva/ecm/veevaid/infra/contract/SupportedLanguage.java
 *
 * Customer managed translations, i.e. Norwegian, are not supported in VeevaID. See https://jira.veevadev.com/browse/DEV-595008
 * For the full list of supported languages supported in Vault, see https://platform.veevavault.help/en/lr/16678/
 */
export default Object.freeze({
    de: {
        label: 'Deutsch',
        testShortForm: true,
        browserLanguageKey: ['de'],
    },
    en: {
        label: 'English',
        testShortForm: true,
        browserLanguageKey: ['en'],
    },
    es: {
        label: 'Español',
        testShortForm: true,
        browserLanguageKey: ['es'],
    },
    fr: {
        label: 'Français',
        testShortForm: true,
        browserLanguageKey: ['fr'],
    },
    hu: {
        label: 'Magyar',
        testShortForm: true,
        browserLanguageKey: ['hu'],
    },
    it: {
        label: 'Italiano',
        testShortForm: true,
        browserLanguageKey: ['it'],
    },
    ja: {
        label: '日本語',
        testShortForm: true,
        browserLanguageKey: ['ja'],
    },
    kr: {
        label: '한국어',
        testShortForm: true,
        browserLanguageKey: ['ko'], // NOTE: "kr" is technically Kanuri but messages_kr is meant for Korean.
    },
    nl: {
        label: 'Nederlands',
        testShortForm: true,
        browserLanguageKey: ['nl'],
    },
    pl: {
        label: 'Polski',
        testShortForm: true,
        browserLanguageKey: ['pl'],
    },
    pt_BR: {
        label: 'Português (Brasil)',
        testShortForm: false,
        browserLanguageKey: ['pt', 'pt-BR'],
    },
    pt_PT: {
        label: 'Português (Portugal)',
        testShortForm: false,
        browserLanguageKey: ['pt-PT'],
    },
    ru: {
        label: 'Pусский',
        testShortForm: true,
        browserLanguageKey: ['ru'],
    },
    sv: {
        label: 'Svenska',
        testShortForm: true,
        browserLanguageKey: ['sv'],
    },
    th: {
        label: 'ภาษาไทย',
        testShortForm: true,
        browserLanguageKey: ['th'],
    },
    tr: {
        label: 'Türk',
        testShortForm: true,
        browserLanguageKey: ['tr'],
    },
    zh_TW: {
        label: '中文 (繁體)',
        testShortForm: false,
        browserLanguageKey: ['zh-HK', 'zh-TW'],
    },
    zh: {
        label: '中文 (简体)',
        testShortForm: false,
        browserLanguageKey: ['zh-CN', 'zh'],
    },
});
